/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Url_LabelInputs */

const vi_trace_url_label = /** @type {(inputs: Trace_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn`)
};

/**

* @param {Trace_Url_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_url_label = /** @type {((inputs?: Trace_Url_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Url_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_url_label(inputs)
});